const getPortsMsg = { type: 'getPorts' };

const connectToSerialMsg = (bauds, toPort) => ({ type: 'connectSerial', bauds, port: toPort });

const disconnectSerialMsg = { type: 'disconnectSerial' };

const armMsg = shoudlArm => ({ type: 'arm', result: shoudlArm });

const killPythonProcessMsg = { type: 'killAnyPythonProcess' };

const flightModeMsg = newFlightMode => ({ type: 'setFlighMode', flightMode: newFlightMode });

const requestLogListMsg = { type: 'requestLogList' };

const requestLogMsg = (logId, logDir) => ({ type: 'requestLog', id: logId, path: logDir });

const deleteAllLogsMsg = { type: 'logErase' };

const askForWPListMsg = { type: 'askForWpList' };

const askForWPMsg = seqNumber => ({ type: 'askForWp', seq: seqNumber });

const sendWaypointsMsg = waypointTelArray => ({ type: 'sendWps', data: waypointTelArray });

const sendDroneToWpMsg = waypointNumber => ({ type: 'sendDroneToWp', wp: waypointNumber });

const triggerCameraMsg = { type: 'cameraTrigger' };

const sendDroneToCoorsMsg = waypointCoords => ({
  type: 'sendDroneToCoors',
  x: waypointCoords[1], // LATITUD
  y: waypointCoords[0], // LONGITUD
  z: waypointCoords[2]
});

const calPitotMsg = { type: 'calPitot' };

const calAccelMsg = { type: 'calAccel' };

const calAccelNextStepMsg = { type: 'calAccelNextStep' };

const callCompassMsg = { type: 'magical' };

export {
  getPortsMsg,
  connectToSerialMsg,
  disconnectSerialMsg,
  armMsg,
  killPythonProcessMsg,
  flightModeMsg,
  requestLogListMsg,
  requestLogMsg,
  deleteAllLogsMsg,
  askForWPListMsg,
  askForWPMsg,
  sendWaypointsMsg,
  sendDroneToWpMsg,
  triggerCameraMsg,
  sendDroneToCoorsMsg,
  calPitotMsg,
  calAccelMsg,
  calAccelNextStepMsg,
  callCompassMsg
};
